import SettingLayout from './SettingLayout';

export default SettingLayout;
